import api from "../../utils/axios-util";
import Middleware from "../../utils/api-middleware"

export const GetLeadTable = (selectedCampaign) => (dispatch) =>
  new Promise(function (resolve, reject) {
    dispatch({
      type: 'SET_SAVING',
      saving: true
    });
    api.get(`/asterdialer/autodial/sub-filters?id=${selectedCampaign}`).then(response => {
      dispatch({
        type: 'SET_SAVING',
        saving: false
      });

       let res = Middleware("lead", "fetch", response)
               resolve(res);
    }).catch(error => {
     let res = Middleware("lead", "fetch", error.response.data, "catch")
               reject(res);
    })
  });

export const GetColorCode = (module) => (dispatch) =>
new Promise(function (resolve, reject) {
  
  api.get(`/colorcondition?module=${module}`).then(response => {
    
    let res = Middleware("lead", "fetch", response)
    resolve(res);
  }).catch(error => {
    let res = Middleware("lead", "fetch", error.response.data, "catch")
    reject(res);
  })
});
  
export const GetLeadSearch = (payload) => (dispatch) =>
  new Promise(function (resolve, reject) {
    dispatch({
      type: 'SET_SAVING',
      saving: true
    });
    api.post(`/fetch/record`, payload).then(response => {
      dispatch({
        type: 'SET_SAVING',
        saving: false
      });

      let res = Middleware("lead", "fetch", response)
      resolve(res);
    }).catch(error => {
      let res = Middleware("lead", "fetch", error.response.data, "catch")
    reject(res);
    })
  });
export const filterCustommodule = (payload) => (dispatch) =>
  new Promise(function (resolve, reject) {
    dispatch({
      type: 'SET_SAVING',
      saving: true
    });
    api.post(`/asterdialer/Custommodule/filter `, payload).then(response => {
      dispatch({
        type: 'SET_SAVING',
        saving: false
      });

      let res = Middleware("custom module", "fetch", response)
      resolve(res);
    }).catch(error => {
      let res = Middleware("custom module", "fetch", error.response.data, "catch")
      reject(res);
    })
  });
  ///////////////////////////////////////////////////////////////////////////////////////////////////////
export const GetLeadStataus = (payload) => (dispatch) =>
  new Promise(function (resolve, reject) {
    dispatch({
      type: 'SET_SAVING',
      saving: true
    });
    api.get(`/fetch/lead?status=Active`).then(response => {
      dispatch({
        type: 'SET_SAVING',
        saving: false
      });

      let res = Middleware("leads", "fetch", response)
      resolve(res);
    }).catch(error => {
      let res = Middleware("leads", "fetch", error.response.data, "catch")
      reject(res);
    })
  });

// export const AsterLeadFetch = (leadNumber) => (dispatch) =>
//   new Promise(function (resolve, reject) {
//     dispatch({
//       type: 'SET_SAVING',
//       saving: true
//     });
//     api.get(`/asterdialer/customer?number=${leadNumber}`).then(response => {
//       dispatch({
//         type: 'SET_SAVING',
//         saving: false
//       });

//       resolve(response);
//     }).catch(error => {
//       reject(error);
//     })
//   });

// export const GetCustomerTimeline = (payload) => (dispatch) =>
//   new Promise(function (resolve, reject) {
//     dispatch({
//       type: 'SET_SAVING',
//       saving: true
//     });
//     api.post(`/asterdialer/customer/timeline`, payload).then(response => {
//       dispatch({
//         type: 'SET_SAVING',
//         saving: false
//       });

//       resolve(response);
//     }).catch(error => {
//       reject(error);
//     })
//   });

export const CallActivity = (data) => {

  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      // http://localhost:4001
      await api
        .post(`/doocity/timeline/call_activity?phone_number=${data.phone_number}&id=${data.id}&skip=${data.skip}&take=${data.take}&module=${data.module}`,{lead_id:data.lead_id})
        .then((response) => {

          let res = Middleware("leads activity", "fetch", response)
      resolve(res);
        })
        .catch((err) => {
          let res = Middleware("leads activity", "fetch", err.response.data, "catch")
          reject(res);
        });
    });
  };
};

export const HistoryTimeline = (data) => {

  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      let url = `/doocity/history?id=${data.id}&skip=${data.skip}&take=${data.take}&module=${data.module}`
      if (data.module === "lead") {
        url += `&templateName=${data.template_name}`
      }
      await api
        .get(url)
        .then((response) => {

          let res = Middleware("leads", "fetch", response)
          resolve(res);
        })
        .catch((err) => {
          let res = Middleware("leads", "fetch", err.response.data, "catch")
          reject(res);
        });
    });
  };
};


// export const MeetingFetch = (value) => {
//   return (dispatch, getState) => {
//     return new Promise(async (resolve, reject) => {
//       await api
//         .get(`/asterdialer/meetings?userID=${value.userID}&skip=${value.skip}&take=${value.take}`)
//         .then((response) => {
//           resolve(response);
//         })
//         .catch((err) => {
//           reject(err);
//         });
//     });
//   };
// };

export const CreateNote = (payload) => (dispatch) =>
  new Promise(function (resolve, reject) {
    api.post(`/notelog/create`, payload).then(response => {
      dispatch({
        type: 'SET_SAVING',
        saving: false
      });

      let res = Middleware("notes", "create", response)
      resolve(res);
    }).catch(error => {
      let res = Middleware("notes", "create", error.response.data, "catch")
          reject(res);
    })
  });

export const LeadScript = (payload) => (dispatch) =>
  new Promise(function (resolve, reject) {
    api.get(`/aster/script?script_name=${payload}&status=ACTIVE`).then(response => {

      let res = Middleware("script", "fetch", response)
      resolve(res);
    }).catch(error => {
      let res = Middleware("script", "fetch", error.response.data, "catch")
          reject(res);
    })
  });


  export const GetSource = () => () =>
  new Promise(function (resolve, reject) {
    api.get(`/source/fetch?active=0`).then(response => {
      let res = Middleware("source", "fetch", response)
      resolve(res);
    }).catch(error => {
      let res = Middleware("source", "fetch", error.response.data, "catch")
      reject(res);
    })
  });

export const getfilter = (module) => () =>
  new Promise(function (resolve, reject) {
    let teamdata = JSON.parse(localStorage.getItem("Teaminfo"))
    let source = []
    let campaign = localStorage.getItem("selectedCampaign");
    if (Object.keys(teamdata).length > 0) {
      if (teamdata.type == "all" || teamdata.type == "source") {
        source = teamdata.type_data.source.map((elm) => elm.name)
      }
    }
    api.get(`/asterdialer/autodial/get-filters?user_name=${localStorage.getItem('user')}&module=${module}&template_name=${JSON.parse(localStorage.getItem('selectedCampaign_data')).template_name}&source=${source}&campaign_name=${campaign}`).then(response => {
      let res = Middleware("lead filter", "fetch", response)
      resolve(res);
    }).catch(error => {
      let res = Middleware("lead filter", "fetch", error.response.data, "catch")
      reject(res);
    })
  });

  export const addfilter = (payload) => () =>
  new Promise(function (resolve, reject) {
    api.post("/asterdialer/autodial/add-filters", payload).then(response => {
      let res = Middleware("lead filter", "create", response)
      resolve(res);
    }).catch(error => {
      let res = Middleware("lead filter", "create", error.response.data, "catch")
      reject(res);
    })
  });

  export const getfilterdata = (data) => () =>
  new Promise(function (resolve, reject) {
    data['template_name']= JSON.parse(localStorage.getItem('selectedCampaign_data')).template_name
    api.post(`/asterdialer/autodial/sub-filters`,data).then(response => {
      let res = Middleware("lead filter", "fetch", response)
      resolve(res);
    }).catch(error => {
      let res = Middleware("lead filter", "fetch", error.response.data, "catch")
      reject(res);
    })
  });
  export const GetTimezone = () => () =>
  new Promise(function (resolve, reject) {
    api.get(`/timezone/fetch?skip=&take=&status=Y`).then(response => {
      let res = Middleware("timezone", "fetch", response)
      resolve(res);
     
    }).catch(error => {
      let res = Middleware("timezone", "fetch", error.response.data, "catch")
      reject(res);
    })
  });
  export const Getsearch = (url,payload) => (dispatch) =>
    new Promise(function (resolve, reject) {
      dispatch({
        type: 'SET_SAVING',
        saving: true
      });
      api.post(url,payload).then(response => {
        dispatch({
          type: 'SET_SAVING',
          saving: false
        });
  
        let res = Middleware("common search", "fetch", response)
        resolve(res);
      }).catch(error => {
        let res = Middleware("common search", "fetch", error.response.data, "catch")
        reject(res);
      })
    });

    // export const GetCommonSearch = (module,payload) => (dispatch) =>
    //   new Promise(function (resolve, reject) {
    //     api.post(`/commonsearch?module=${module}`,payload).then(response => {
    //       resolve(response);
    //     }).catch(error => {
    //       reject(error);
    //     })
    //   });
